// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".outing-table-component .consented-btn[data-v-c08ca5f6],.outing-table-component .detail-btn[data-v-c08ca5f6],.outing-table-component .refuse-btn[data-v-c08ca5f6]{min-width:57px}.outing-table-component .cancel-btn[data-v-c08ca5f6]{min-width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
